export const VERSION = "17.9.2";
